module.exports = __webpack_public_path__ + "assets/img/scroll.1a86497f.svg";